import { Dimensions, Platform, StatusBar } from 'react-native';

export const isAndroidWithNotch = Platform.OS === 'android' && StatusBar.currentHeight! > 24;
export const isAndroid = Platform.OS === 'android';
export const isIOS = Platform.OS === 'ios';

export const isDeviceWithNotch = (): boolean => {
  // This check is only for iOS devices and excludes iPads and Apple TVs
  if (Platform.OS !== 'ios' || Platform.isPad || Platform.isTV) {
    return false;
  }

  // Get the window dimensions
  const { width, height } = Dimensions.get('window');
  // Arrange dimensions so that maxDim is always the greater value (to handle device rotation)
  const [maxDim, minDim] = [Math.max(width, height), Math.min(width, height)];

  // List of [height, width] pairs (in points) for iPhones with a notch (but not Dynamic Island)
  const notchedDevices: [number, number][] = [
    [812, 375], // iPhone X, XS, 11 Pro
    [896, 414], // iPhone XR, 11, XS Max, 11 Pro Max
    [780, 360], // iPhone 12 mini, 13 mini
    [844, 390], // iPhone 12, 12 Pro, 13, 13 Pro, 14 (6.1-inch non-Pro)
    [926, 428], // iPhone 12 Pro Max, 13 Pro Max, 14 Plus (6.7-inch)
    [932, 430], // iPhone 15 Plus, 15 Pro Max, 16 Plus (6.7-inch non-Pro)
  ];

  // Check if the device's dimensions match any of the known notched devices
  return notchedDevices.some(([h, w]) => h === maxDim && w === minDim);
};

export const isDeviceWithDynamicIsland = (): boolean => {
  // This check is only for iOS devices and excludes iPads and Apple TVs
  if (Platform.OS !== 'ios' || Platform.isPad || Platform.isTV) {
    return false;
  }

  // Get the window dimensions
  const { width, height } = Dimensions.get('window');
  // Arrange dimensions so that maxDim is always the greater value (to handle device rotation)
  const [maxDim, minDim] = [Math.max(width, height), Math.min(width, height)];

  // List of [height, width] pairs (in points) for iPhones with Dynamic Island
  const dynamicIslandDevices: [number, number][] = [
    [852, 393], // iPhone 14 Pro, 15, 15 Pro, 16 (6.1-inch Pro)
    [874, 402], // iPhone 16 Pro (6.3-inch Pro)
    [932, 430], // iPhone 14 Pro Max, 15 Pro Max (6.7-inch Pro)
    [956, 440], // iPhone 16 Pro Max (6.9-inch Pro)
  ];

  // Check if the device's dimensions match any of the known Dynamic Island devices
  return dynamicIslandDevices.some(([h, w]) => h === maxDim && w === minDim);
};

export type DeviceType = 'phone' | 'ipad';
